import { render, staticRenderFns } from "./DocumentSeriesAllocationListToolbar.vue?vue&type=template&id=0297952a&"
import script from "./DocumentSeriesAllocationListToolbar.vue?vue&type=script&lang=js&"
export * from "./DocumentSeriesAllocationListToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports